<div class="container information-card {{styleClass}}">
    <div class="row">
        <div class="col" role="region" aria-label="Inforamtion card">
            <div class="icon-header">
                <i class="bi {{iconClass}}" *ngIf="showEdit && !iconSVG"></i>
                <img [src]="'data:image/svg+xml;base64,'+iconSVG" *ngIf="iconSVG" alt="icon" class="svg-icon" />
            </div>
            <div class="title">
                <div [outerHTML]="title">
                </div>
            </div>
            <div class="description">
                <div [outerHTML]="description">
                </div>
            </div>
            <div class="poblation" *ngIf="showPoblation">
                <select class="form-select" name="poblation" id="poblation" [(ngModel)]="poblation" (change)="onButtonClick()">
                    <option value="">Selecciona un municipio</option>
                    <option *ngFor="let p of municipalities" [value]="p.municipality.municipalityName">{{p.municipality.municipalityName}}</option>
                </select>
            </div>
            <div class="actions" [hidden]="hideButtons || showPoblation">
                <button class="btn btn-{{styleClass}}" (click)="onButtonClick()" [disabled]="showPoblation && poblation==''" i18n>{{buttonText}}</button>
            </div>
        </div>
    </div>
</div>